import produce from 'immer';
export var getInitialState = function () { return ({
    builds_loading: false,
    builds_error: false,
    builds: [],
    buildError: {
        buildId: '',
        errorLogLoading: false,
        errorLogLoadError: false,
        errorMsg: '',
    },
    downloadLink: '',
    expiry: 0,
    downloadLink_loading: false,
    downloadLink_error: false,
    retry_loading: false,
    retry_error: false,
    retry_conflict: false,
    version: { major: 0, minor: 0, patch: 0 },
    version_loading: false,
    version_error: false,
    publishedDates_loading: false,
    publishedDates_error: false,
    publishedDates: {},
}); };
function buildReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'APP_BUILD_PLATFORM_VERSION_REQUEST':
                state.version_loading = true;
                state.version_error = false;
                break;
            case 'APP_BUILD_PLATFORM_VERSION_SUCCESS':
                state.version_loading = false;
                state.version_error = false;
                state.version = action.version || { major: 0, minor: 0, patch: 0 };
                break;
            case 'APP_BUILD_PLATFORM_VERSION_FAIL':
                state.version_loading = false;
                state.version_error = true;
                break;
            case 'APP_BUILD_RETRY_REQUEST':
                state.retry_loading = true;
                state.retry_error = false;
                state.retry_conflict = false;
                break;
            case 'APP_BUILD_RETRY_SUCCESS':
                state.retry_loading = false;
                state.retry_error = false;
                state.retry_conflict = false;
                break;
            case 'APP_BUILD_RETRY_FAIL':
                state.retry_loading = false;
                state.retry_error = true;
                state.retry_conflict = false;
                break;
            case 'APP_BUILD_RETRY_CONFLICT':
                state.retry_loading = false;
                state.retry_error = false;
                state.retry_conflict = true;
                break;
            case 'APP_BUILD_DOWNLOAD_LINK_REQUEST':
                state.downloadLink_loading = true;
                state.downloadLink_error = false;
                break;
            case 'APP_BUILD_DOWNLOAD_LINK_SUCCESS':
                state.downloadLink_loading = false;
                state.downloadLink_error = false;
                state.downloadLink = action.downloadLink || '';
                state.expiry = action.expiry || 0;
                break;
            case 'APP_BUILD_DOWNLOAD_LINK_FAIL':
                state.downloadLink_loading = false;
                state.downloadLink_error = true;
                break;
            case 'APP_BUILD_ERROR_LOG_RESET':
                state.buildError.buildId = '';
                state.buildError.errorMsg = '';
                break;
            case 'APP_BUILD_ERROR_LOG_REQUEST':
                state.buildError.errorLogLoading = true;
                state.buildError.errorLogLoadError = false;
                break;
            case 'APP_BUILD_ERROR_LOG_SUCCESS':
                state.buildError.buildId = action.buildId || '';
                state.buildError.errorMsg = action.errorMsg || '';
                break;
            case 'APP_BUILD_ERROR_LOG_FAIL':
                state.buildError.buildId = '';
                state.buildError.errorLogLoading = false;
                state.buildError.errorLogLoadError = true;
                break;
            case 'APP_BUILD_CLEAR':
                state.builds_loading = false;
                state.builds_error = false;
                state.builds = [];
                break;
            case 'APP_BUILD_FETCH_REQUEST':
                state.builds_loading = true;
                state.builds_error = false;
                break;
            case 'APP_BUILD_FETCH_SUCCESS':
                state.builds_loading = false;
                state.builds_error = false;
                state.builds = action.builds || [];
                break;
            case 'APP_BUILD_FETCH_FAIL':
                state.builds_loading = false;
                state.builds_error = true;
                state.builds = [];
                break;
            case 'APP_PUBLISHED_DATES_REQUEST':
                state.publishedDates_loading = true;
                state.publishedDates_error = false;
                break;
            case 'APP_PUBLISHED_DATES_SUCCESS':
                state.publishedDates_loading = false;
                state.publishedDates_error = false;
                state.publishedDates = action.publishedDates || {};
                break;
            case 'APP_PUBLISHED_DATES_FAIL':
                state.publishedDates_loading = false;
                state.publishedDates_error = true;
                break;
            default:
                break;
        }
    });
}
export default buildReducer;
